import vtkTextureMapToSphere from './TextureMapToSphere';
import vtkTextureMapToPlane from './TextureMapToPlane';

export default {
  vtkTextureMapToPlane,
  vtkTextureMapToSphere,
};
